import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UsuariosService } from '../../../../services/centralization/usuarios.service';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';


@Component({
  selector: 'app-editar-analista',
  templateUrl: './editar-analista.component.html',
  styleUrls: ['./editar-analista.component.css'],
      imports: [
      CommonModule,
      ReactiveFormsModule,
      AutoCompleteModule
    ],
})
export class EditarAnalistaComponent {

  @Input() centroDatos!: any;
  nuevoCentroForm: FormGroup;
  cantroEstadoActivacion: boolean = false;
  switchLabel: string = 'Desactivado';
  analistaIdRespaldo: any = '';
  analistaNombreRespaldo: any = '';
  analistaIdSelected: any = '';
  analistaNombreSelected: any = '';
  analistasFiltrados: any[] = [];
  verErrorAnalistas: boolean = false;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly _usuariosService: UsuariosService,
    private readonly _toastr: ToastrService,
    public activeModal: NgbActiveModal
  ) {
    this.nuevoCentroForm = this._formBuilder.group({
      centroCodigoCompania: ['', [Validators.required]],
      centroNombre: ['', [Validators.required]],
      centroIniciales: ['', [Validators.required]],
      centroSegmento: ['', [Validators.required]],
      // centroCentroCosto: ['', [Validators.required]],
      centroSociedad: ['', [Validators.required]],
      centroAnalistaFzas: ['', [Validators.required]],
      centroActivacion: [false],
    });
  }

  ngOnInit(): void {
    this.analistaIdRespaldo = this.centroDatos.usId;
    this.analistaNombreRespaldo = this.centroDatos.centProcAnalistaFinanza;
    this.analistaIdSelected = this.centroDatos.usId;
    this.analistaNombreSelected = this.centroDatos.centProcAnalistaFinanza;
    console.log(this.analistaNombreRespaldo + '-' + this.analistaNombreSelected);
    console.log(this.analistaIdRespaldo + '-' + this.analistaIdSelected);
    this.nuevoCentroForm.controls['centroCodigoCompania'].setValue(this.centroDatos.centProcCodCompania);
    this.nuevoCentroForm.controls['centroCodigoCompania'].disable();
    this.nuevoCentroForm.controls['centroNombre'].setValue(this.centroDatos.centProcNombre);
    this.nuevoCentroForm.controls['centroNombre'].disable();
    this.nuevoCentroForm.controls['centroIniciales'].setValue(this.centroDatos.centProcIniciales);
    this.nuevoCentroForm.controls['centroIniciales'].disable();
    this.nuevoCentroForm.controls['centroSegmento'].setValue(this.centroDatos.centProcSegmento);
    this.nuevoCentroForm.controls['centroSegmento'].disable();
    // this.nuevoCentroForm.controls['centroCentroCosto'].setValue(this.centroDatos.centProcCentroCosto);
    // this.nuevoCentroForm.controls['centroCentroCosto'].disable();
    this.nuevoCentroForm.controls['centroSociedad'].setValue(this.centroDatos.centProcSociedad);
    this.nuevoCentroForm.controls['centroSociedad'].disable();
    this.nuevoCentroForm.controls['centroAnalistaFzas'].setValue(this.centroDatos.centProcAnalistaFinanza);
    this.nuevoCentroForm.controls['centroActivacion'].setValue(this.centroDatos.centProcActivado == 1 ? true : false);
    this.nuevoCentroForm.controls['centroActivacion'].disable();
    this.cantroEstadoActivacion = this.centroDatos.centProcActivado == 1 ? true : false;
    this.switchLabel = this.nuevoCentroForm.controls['centroActivacion'].value ? 'Activado' : 'Desactivado';
  }

  buscarAnalistas(event: any) {
    const query = event.query;
    this._usuariosService.listarUsuariosAnalistas(query).subscribe({
      next: (res: any[]) => {
        if (res.length === 0) {
          this.analistasFiltrados = [];
          this.verErrorAnalistas = true;
        } else {
          this.verErrorAnalistas = false;
          this.analistasFiltrados = res
            .filter((user: any) =>
              user.us_nombres.toLowerCase().includes(query.toLowerCase())
            )
            .map((user: any) => ({
              name: user.us_nombres,
              code: user.us_id
            }));
        }
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  onSelectAnalista(event: any) {
    console.log('Datos del analista seleccionado:', event);
    this.analistaNombreSelected = event.value.name;
    this.analistaIdSelected = event.value.code;
    console.log('Datos del analista seleccionado:', this.nuevoCentroForm.controls['centroAnalistaFzas'].value);
  }

  aceptar() {
    if (this.verErrorAnalistas) {
      this._toastr.warning('No se puede continuar con la edicion de analista. Por favor, seleccione un analista valido.', 'Advertencia');
      return;
    }

    console.log(this.analistaNombreRespaldo + '-' + this.analistaNombreSelected);
    console.log(this.analistaIdRespaldo + '-' + this.analistaIdSelected);

    if (this.analistaNombreRespaldo != this.analistaNombreSelected && this.analistaIdRespaldo != this.analistaIdSelected) {
      this.activeModal.close(this.nuevoCentroForm.controls['centroAnalistaFzas'].value);
    } else {
      this.activeModal.close(false);
    }
  }

  salir(estado: any) {
    this.activeModal.close(estado);
  }

  validarAlfanumerico(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;
    const valorValidado = valor.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚ ]/g, '');
    if (valor !== valorValidado) {
      input.value = valorValidado;
      this.nuevoCentroForm.controls['centroAnalistaFzas'].setValue(valorValidado);
    }
  }
}